import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const ModalSubitleStyles = {
  SubtitleWrapper: styled.div`
    margin: ${tokens.spacer.x3} 0;
  `,
  FullCoverageBenenfits: styled.div`
    ${tokens.text('body1')};
    margin-top: ${tokens.spacer.x0pt5};
  `,
};
